import { render, staticRenderFns } from "./p_footer037.vue?vue&type=template&id=b5f9c9a8&scoped=true&"
import script from "./p_footer037.vue?vue&type=script&lang=js&"
export * from "./p_footer037.vue?vue&type=script&lang=js&"
import style0 from "./p_footer037.vue?vue&type=style&index=0&id=b5f9c9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f9c9a8",
  null
  
)

export default component.exports